// extracted by mini-css-extract-plugin
export default {"logo":"LandingPage_logo__VpS3a","linkButton":"LandingPage_linkButton__n14la"};